import styled, { css, keyframes } from 'styled-components';

const glowUp = keyframes`
  0% { box-shadow: 0 0 0 rgba(82, 196, 26, 0); border-color: rgba(82, 196, 26, 0.8); }
  50% { box-shadow: 0 0 20px rgba(82, 196, 26, 0.4); border-color: rgba(82, 196, 26, 0.6); }
  100% { box-shadow: 0 0 0 rgba(82, 196, 26, 0); border-color: rgba(255, 255, 255, 0.06); }
`;

const glowDown = keyframes`
  0% { box-shadow: 0 0 0 rgba(255, 59, 62, 0); border-color: rgba(255, 59, 62, 0.8); }
  50% { box-shadow: 0 0 20px rgba(255, 59, 62, 0.3); border-color: rgba(255, 59, 62, 0.5); }
  100% { box-shadow: 0 0 0 rgba(255, 59, 62, 0); border-color: rgba(255, 255, 255, 0.06); }
`;

export const ListWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListHeader = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 120px 80px 100px;
  padding: 12px 20px;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    grid-template-columns: 60px 1fr 80px 60px 80px;
    padding: 10px 12px;
    font-size: 10px;
  }
`;

export const Row = styled.div<{ isEven: boolean; highlight?: 'up' | 'down' | null }>`
  display: grid;
  grid-template-columns: 80px 1fr 120px 80px 100px;
  align-items: center;
  padding: 14px 20px;
  border-radius: 16px;
  background: ${({ isEven }) =>
    isEven ? 'rgba(255, 255, 255, 0.06)' : 'rgba(255, 255, 255, 0.03)'};
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: background 0.2s ease;

  ${({ highlight }) =>
    highlight === 'up' &&
    css`
      animation: ${glowUp} 1.5s ease-out forwards;
    `}

  ${({ highlight }) =>
    highlight === 'down' &&
    css`
      animation: ${glowDown} 1.5s ease-out forwards;
    `}

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 768px) {
    grid-template-columns: 60px 1fr 80px 60px 80px;
    padding: 10px 12px;
  }
`;

export const PositionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Position = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
`;

export const ChangeIndicator = styled.span<{ direction: 'up' | 'down' }>`
  font-size: 12px;
  font-weight: 700;
  color: ${({ direction }) => (direction === 'up' ? '#52C41A' : '#FF3B3E')};
  display: flex;
  align-items: center;
  gap: 1px;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const SmallAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const SmallAvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  background: linear-gradient(135deg, #08966c, #0abb87);
`;

export const UserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ScoreValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 0 8px rgba(10, 187, 135, 0.3);
  text-align: left;
`;

export const TestsValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
`;

export const TimeValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  font-variant-numeric: tabular-nums;
  text-align: left;
`;
